// The variation axis of a generation run, in words rather than enum values.
//
// Lifted out of GenerationOutput so the group dialog can label its member
// tiles with the same wording — importing it back from GenerationOutput would
// be a cycle (GenerationOutput renders the dialog).

import { GenerationRow } from './types';

// close/fresh/concept are LEGACY values still on rows generated before the
// five axes replaced the old similarity setting.
export const SIMILARITY_LABEL: Record<string, string> = {
  faithful: 'faithful',
  copy_swap: 'copy swap',
  composition_shift: 'composition shift',
  mood_shift: 'mood shift',
  wild_card: 'wild card',
  close: 'faithful (legacy close)',
  fresh: 'mood shift (legacy fresh)',
  concept: 'wild card (legacy concept)',
};

export const SIMILARITY_TIP: Record<string, string> = {
  faithful: 'Faithful — same ad, product swapped. The source ad image was attached as a reference.',
  copy_swap: 'Copy swap — same look, new messaging angle. The source ad image was attached as a reference.',
  composition_shift: 'Composition shift — same copy and palette, new layout. Source ad not shown to the image model.',
  mood_shift: 'Mood shift — same layout and hook, new palette/lighting/lens. Source ad not shown to the image model.',
  wild_card: 'Wild card — keeps only the hook and rebuilds everything else, possibly switching aspect.',
  close: 'Close match (legacy) — the source ad was attached as a reference; the output is meant to hew closely to it, product swapped.',
  fresh: 'Fresh take (legacy) — the source ad guided the prompt but was NOT shown to the image model; the output should be visibly different.',
  concept: 'Concept remix (legacy) — only the core idea kept (hook, comparison, persuasion); layout and look invented fresh.',
};

// Axes that send the source ad image along as a reference — flagged with a
// warning-colored chip because the output may hew close to someone else's ad.
// The row's own sourceAdAttached is authoritative (a template run suppresses
// attachment even on these axes); the set is only the fallback for old rows.
export const SOURCE_ATTACHED_AXES = new Set(['faithful', 'copy_swap', 'close']);

export const rowSourceAttached = (row: GenerationRow): boolean => (
  row.sourceAdAttached != null ? !!row.sourceAdAttached : SOURCE_ATTACHED_AXES.has(row.similarity || '')
);
